import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const editCurrentUserRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/user/profile',
}).lazy(() => import('pages/shared/Profile/ProfilePage/ProfilePage').then((d) => d.Route));
